import { usePreventInitByRoute } from '@st/use/composables'
import { useUserStore } from '@st/user/stores/useUserStore'

export default defineNuxtPlugin({
  name: 'init-sockets',
  setup: () => {
    const { isReady } = storeToRefs(useUserStore())
    const app = useNuxtApp()

    function init() {
      app.$io.connect()
    }

    onNuxtReady(async () => {
      await until(isReady).toBeTruthy()
      const restrictionRoutes = ['/promo/registration']
      usePreventInitByRoute(restrictionRoutes, init)
    })
  },
})
